import React, {useEffect, useState} from "react";
import { postUserSex } from "../../service";
import {getUserStorage} from "../../units";
import {useLoading} from "../../components/loading/LoadingProvider";
import useUserInfo from "../../routers/useUserInfo";
import {useDispatch} from "react-redux";
import {userInfoAction} from "../../store/actions";

const classnames = require('classnames')

const Sex: React.FC<{ sex: number }> = (props) => {
    const lists = ['保密','男士', '女士'];
    const [active, setActive] = useState<number>(props.sex)
    const userData = useUserInfo()
    const loading =  useLoading()
    const dispatch = useDispatch()

    // console.log(props.sex)

    const changeHandle = (sex:number) => {
        if(userData){
            postUserSex({
                userId:userData.id,
                sex
            }).then(res => {
                if(res.code === 1){
                    loading.showSuccess()
                    setActive(sex)
                    dispatch(userInfoAction(Object.assign({},userData,{ sex })))
                }
            })
        }
    }

    return <div className="sex-lists">
        {
            lists.map((item,index) => {
                return <div className={classnames("sex-item",{ 'active':index === active })} onClick={() => changeHandle(index)} key={index}>
                    <div className="c"/>
                    <p>{ item }</p>
                </div>
            })
        }
    </div>
}

export default Sex
